<template>
  <div class="mine">
    <div class="banner">
      <img src="../assets/mine/banner.png" alt="">
      <div class="roleshow">
        <p>
          <span :title="username">{{username}}</span>
          <span>{{role}}</span>
          <span >{{list.authentation}}</span>
        </p>
      </div>
    </div>
    <div class="content">
      <a-layout id="components-layout-demo-custom-trigger">
        <a-layout-sider :trigger="null" >
          <a-menu
            :selectedKeys="selectedKeys"
            :open-keys="openKeys"
            @openChange="onOpenChange"
            @click="changePage"
            theme="dark"
            mode="inline"
          >
          <a-menu-item key="1">
            <em></em><span>基本信息</span>
          </a-menu-item>
          <a-menu-item key="2">
            <span class="subject"></span><span>我的课程</span>
          </a-menu-item>
          <a-menu-item key="3"  v-if="this.role =='学生'">
            <span class="banji"></span><span>我的班级</span>
          </a-menu-item>
          <a-menu-item key="3" v-else-if="this.role == '教师'&&list.authentation =='VIP会员'">
            <span class="banji"></span><span>班级管理</span>
          </a-menu-item>
          <a-menu-item key="4">
            <span class="zhibao"></span><span>我的训练</span>
          </a-menu-item>
          <!-- <a-sub-menu key="sub1">
            <div slot="title" class="mid"><em></em><span>培训与考试</span></div>
            <a-menu-item key="5-1">
              我的培训
            </a-menu-item>
            <a-menu-item key="5-2"> 
             我的考试
            </a-menu-item>
          </a-sub-menu>           -->
          <a-menu-item key="6">
            <span class="score"></span><span>成绩与证书</span>
          </a-menu-item>
          <a-menu-item key="7">
            <span class="myar"></span><span>我的问答</span>
          </a-menu-item>
          <a-menu-item key="8" class="newsitem">
            <span class="mynews"></span><span>我的消息</span><span v-if="msgStatus==1" class="redspan"></span>
          </a-menu-item>
            <!-- <template v-for="item in menulist">
              <a-sub-menu
                :key="item.key"
                v-if="item.children"
              >
                <span slot="title"><a-icon type="notification" /><span>{{item.name}}</span></span>
                <a-menu-item
                  :key="value.key"
                  v-for="value in item.children"
                >
                  {{value.name}}
                </a-menu-item>
              </a-sub-menu>
              <a-menu-item
                v-else
                :key="item.key"
              >
                <span><a-icon type="user" />{{item.name}}</span>
              </a-menu-item>
            </template> -->
          </a-menu>
        </a-layout-sider>
        <a-layout>
          <a-layout-content :style="{ background: '#fff', minHeight: '500px' }">
            <router-view></router-view>
          </a-layout-content>
        </a-layout>
      </a-layout>
    </div>
    <div class="gohead" v-show="flaghead">
      <a href="#layout"></a>
    </div>
  </div>
</template>
<script>
import {getmyInfo,getinstituteCenterApi} from "@/request/api";
export default {
  watch: {
    $route(to) {
      if(to.fullPath=='/basicInfos'){
        this.selectedKeys=['1']
      }else if(to.fullPath=='/basicInfo'){
          this.selectedKeys=['1']
      }
    },
  },
  data() {
    return {
      selectedKeys: ["1"],
      rootSubmenuKeys: ["sub1"],
      openKeys: [],
      list:[],
      infolist:[],
      newMessage:'',
      flaghead: false
    };
  },
  created(){
     this.init()
  },
  
  mounted() {

   window.addEventListener("scroll", this.watchScroll);

    let arr = window.location.pathname.split("/");
    switch (arr[arr.length - 1]) {
      case "mysubject":
        this.selectedKeys = ["2"];
        break;
      case "basicInfos":
        this.selectedKeys = ["1"];
        break;
      case "basicInfo":
        this.selectedKeys = ["1"];
        break;
      case "mytrain":
        this.openKeys = ["sub1"];
        this.selectedKeys = ["5-1"];
        break;
      case "invlintrain":
        this.openKeys = ["sub1"];
        this.selectedKeys = ["5-1"];
        break;
      case "myexam":
        this.openKeys = ["sub1"];
        this.selectedKeys = ["5-2"];
        break;
       case "invlinexam":
        this.openKeys = ["sub1"];
        this.selectedKeys = ["5-2"];
        break;
      case "myClass":
        this.selectedKeys = ["3"];
        break;
      case "mystudent":
      this.selectedKeys = ["3"];
      break;
      case "manClass":
        this.selectedKeys = ["3"];
        break;
      case "manstudent":
      this.selectedKeys = ["3"];
      break;
      case "studyview":
      this.selectedKeys = ["3"];
      break;
      case "myviedo":
        this.selectedKeys = ["4"];
      break;
      case "myscore":
        this.selectedKeys = ["6"];
        break;
      case "myask":
        this.selectedKeys = ["7"];
        break;
      case "myreply":
        this.selectedKeys = ["7"];
        break;
      case "message":
        this.selectedKeys = ["8"];
        break;
      case "Site":
        this.selectedKeys = ["9"];
        break;
      case "examplan":
        this.openKeys = ["sub2"];
        this.selectedKeys = ["10-1"];
        break;
      case "newexamplan":
        this.openKeys = ["sub2"];
        this.selectedKeys = ["10-1"];
        break;
      case "report":
        this.openKeys = ["sub2"];
        this.selectedKeys = ["10-1"];
        break;
      case "audit":
        this.openKeys = ["sub2"];
        this.selectedKeys = ["10-1"];
        break;
      case "mark":
        this.openKeys = ["sub2"];
        this.selectedKeys = ["10-2"];
        break;
      case "require":
        this.selectedKeys = ["11"];
        break;
      case "newrequire":
        this.selectedKeys = ["11"];
        break;
      case "Delivery":
        this.selectedKeys = ["11"];
        break;
    }
  },
  computed: {
     msgStatus(){
      return this.$store.state.msgStatus;
    },
    role() {
      return this.$store.state.role;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    username() {
      return this.$store.state.username;
    },
    icon() {
      return this.$store.state.icon;
    },
    authentation() {
      return this.$store.state.authentation;
    },
   
  },
  methods: {
    init(){
      if(this.role=="教师"||this.role=="学生"||this.role=="企业人员"){
          this.getToken(getmyInfo, {}, (res) => {
            this.list = res.data;
            this.newMessage=res.data.newMessage
            this.$store.commit('changeMessageStatus',{'status':this.newMessage==0?false:true})
          })
      }else{
           this.getToken(getinstituteCenterApi,{},(res)=>{
            this.infolist=res.data
            // console.log(this.infolist.isAlliance)
            this.newMessage=res.data.newMessage
            this.$store.commit('changeMessageStatus',{'status':this.newMessage==0?false:true})
          })
      }
     
    },       
    onOpenChange(openKeys) {
      const latestOpenKey = openKeys.find(
        (key) => this.openKeys.indexOf(key) === -1
      );
      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys;
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      }
    },
    changePage({ key }) {
      this.selectedKeys = [key];
      if (key == 1&&(this.role=="学生"||this.role=="教师"||this.role=="企业人员")) {
        this.$router.push({ path: "/basicInfo" });
      } else if(key==1&&(this.role=="学校"||this.role=="企业")){
        this.$router.push({ path: "/basicInfos" });
      }else if (key == 2) {
        this.$router.push({ path: "/mysubject" });
      } else if (key == 3 && this.role == "学生") {
        this.$router.push({ path: "/myClass" });
      } else if (key == 3 && this.role == "教师") {
        this.$router.push({ path: "/manClass" });
      } else if (key == 4) {
        this.$router.push({ path: "/myviedo" });
      }
      // else if(key=='sub1'){
      //   this.$router.push({path:'/trainexam'})}
      else if (key == "5-1") {
        this.$router.push({ path: "/mytrain" });
      } else if (key == "5-2") {
        this.$router.push({ path: "/myexam" });
      } else if (key == 6) {
        this.$router.push({ path: "/myscore" });
      } else if (key == 7) {
        this.$router.push({ path: "/myask" });
      } else if (key == 9) {
        this.$router.push({ path: "/Site" });
      }else if (key == "10-1") {
        this.$router.push({ path: "/examplan" });
      }else if (key == "10-2") {
        this.$router.push({ path: "/mark" });
      }else if (key == 11) {
        this.$router.push({ path: "/require" });
      }else {
        this.$router.push({ path: "/message" });
      }
    },
     //返回顶部按钮
    watchScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 100) {
        this.flaghead = true;
      } else {
        this.flaghead = false;
      }
    }
  }
};
</script>
<style>
#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}



#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

#components-layout-demo-custom-trigger .logo {
  height: 10px;
  /* background: rgba(255, 255, 255, 0.2); */
  margin: 16px;
}
.ant-menu-dark, .ant-menu-dark .ant-menu-sub {
    background: #fff;
    color: #333;
}
.ant-menu-dark.ant-menu-inline .ant-menu-item {
  width: 100%;
  /* text-align: center; */
  padding-left: 20px;
  color:#333;
  /* background:#fff; */
  padding-left:20px;
  display:flex;
  align-items: center;
  border-bottom: solid 1px #eff2f2;
}
.ant-menu-dark.ant-menu-inline .ant-menu-item em{
   background:url("../assets/mine/basicInfo1.png");
   display:block;
   width:23px;
   height:22px;
   margin-right:13px;
}
.ant-menu-dark.ant-menu-inline .ant-menu-item-selected em{
   background:url("../assets/mine/basicInfo2.png");
   display:block;
   width:23px;
   height:22px;
   margin-right:13px;
}
.ant-menu-dark.ant-menu-inline .ant-menu-item .jigou{
   background:url("../assets/mine/jigou1.png");
   display:block;
   width:23px;
   height:22px;
   margin-right:13px;
}
.ant-menu-dark.ant-menu-inline .ant-menu-item-selected .jigou{
   background:url("../assets/mine/jigou2.png");
   display:block;
   width:23px;
   height:22px;
   margin-right:13px;
}
.ant-menu-dark.ant-menu-inline .ant-menu-item .mySite{
   background:url("../assets/mine/mySite1.png");
   display:block;
   width:23px;
   height:22px;
   margin-right:13px;
}
.ant-menu-dark.ant-menu-inline .ant-menu-item-selected .mySite{
   background:url("../assets/mine/mySite2.png");
   display:block;
   width:23px;
   height:22px;
   margin-right:13px;
}
.ant-menu-dark.ant-menu-inline .ant-menu-item .subject{
   background:url("../assets/mine/mysubject1.png");
   display:block;
   width:23px;
   height:22px;
   margin-right:13px;
}
.ant-menu-dark.ant-menu-inline .ant-menu-item-selected .subject{
   background:url("../assets/mine/mysubject2.png");
   display:block;
   width:23px;
   height:22px;
   margin-right:13px;
}
.ant-menu-dark.ant-menu-inline .ant-menu-item .banji{
   background:url("../assets/mine/myclass1.png");
   display:block;
   width:23px;
   height:22px;
   margin-right:13px;
}
.ant-menu-dark.ant-menu-inline .ant-menu-item-selected .banji{
   background:url("../assets/mine/myclass2.png");
   display:block;
   width:23px;
   height:22px;
   margin-right:13px;
}
.ant-menu-dark.ant-menu-inline .ant-menu-item .zhibao{
   background:url("../assets/mine/trainandexam1.png");
   display:block;
   width:23px;
   height:22px;
   margin-right:13px;
}
.ant-menu-dark.ant-menu-inline .ant-menu-item-selected .zhibao{
   background:url("../assets/mine/trainandexam2.png");
   display:block;
   width:23px;
   height:22px;
   margin-right:13px;
}
.ant-menu-inline .ant-menu-submenu{
   border-bottom: solid 1px #eff2f2;
}
.ant-menu-sub.ant-menu-inline > .ant-menu-item {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-bottom: 0;
}
 .ant-menu-inline .ant-menu-submenu .mid{
   /* background:pink; */
   width:100%;
   align-items: center;
   display:flex
 }
.ant-menu-inline .ant-menu-submenu .mid em{
   background:url("../assets/mine/trainandexam1.png");
   display:block;
   width:23px;
   height:22px;
   margin-right:13px;
}
.ant-menu-inline .ant-menu-submenu-selected .mid em{
   background:url("../assets/mine/trainandexam1.png");
   display:block;
   width:23px;
   height:22px;
   margin-right:13px;
}
.ant-menu-inline .ant-menu-submenu .examine{
   /* background:pink; */
   width:100%;
   align-items: center;
   display:flex
 }
.ant-menu-inline .ant-menu-submenu .examine em{
   background:url("../assets/mine/examine1.png");
   display:block;
   width:23px;
   height:22px;
   margin-right:13px;
}
.ant-menu-inline .ant-menu-submenu-selected .examine em{
   background:url("../assets/mine/examine1.png");
   display:block;
   width:23px;
   height:22px;
   margin-right:13px;
}
.ant-menu-dark.ant-menu-inline .ant-menu-item .score{
   background:url("../assets/mine/myscore1.png");
   display:block;
   width:23px;
   height:22px;
   margin-right:13px;
}
.ant-menu-dark.ant-menu-inline .ant-menu-item-selected .score{
   background:url("../assets/mine/myscore2.png");
   display:block;
   width:23px;
   height:22px;
   margin-right:13px;
}
.ant-menu-dark.ant-menu-inline .ant-menu-item .myar{
   background:url("../assets/mine/myanswer1.png");
   display:block;
   width:23px;
   height:22px;
   margin-right:13px;
}
.ant-menu-dark.ant-menu-inline .ant-menu-item-selected .myar{
   background:url("../assets/mine/myanswer2.png");
   display:block;
   width:23px;
   height:22px;
   margin-right:13px;
}
.ant-menu-dark.ant-menu-inline .ant-menu-item .require{
   background:url("../assets/mine/require1.png");
   display:block;
   width:23px;
   height:22px;
   margin-right:13px;
}
.ant-menu-dark.ant-menu-inline .ant-menu-item-selected .require{
   background:url("../assets/mine/require2.png");
   display:block;
   width:23px;
   height:22px;
   margin-right:13px;
}
.ant-menu-dark.ant-menu-inline .ant-menu-item  .mynews{
   background:url("../assets/mine/message1.png");
   display:block;
   width:23px;
   height:22px;
   margin-right:13px;
}
/* .ant-menu-dark.ant-menu-inline .newsitem{
  position: relative;
} */
.ant-menu-dark.ant-menu-inline .newsitem .redspan{
  background:url("../assets/mine/nonews.png") no-repeat;
  display:block;
  width:6px;
  /* background:yellow; */
  height:22px;

}
.ant-menu-dark.ant-menu-inline .ant-menu-item-selected .mynews{
   background:url("../assets/mine/message2.png");
   display:block;
   width:23px;
   height:22px;
   margin-right:13px;
}
            
.ant-layout-content {
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  margin-left:15px;
  min-height:600px !important;
  /* background:pink; */
}
.ant-layout-sider-children {
    /* background:#fff; */
    margin-top: -0.1px;
    padding-top: 0.1px;
    color:#333 !important;
}
.ant-layout-sider {
   background:#fff;
   color:#333;
   /* max-height:365px; */
}
.ant-layout {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 1;
    -ms-flex: auto;
    flex: auto;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    min-height: 0;
    background: #eee;
}
/* .ant-menu{
  color:#333;
} */
.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background-color: #d4aa0f;
    color: #fff;
}
.ant-menu.ant-menu-dark .ant-menu-item-selected, .ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected {
    background-color: #d4aa0f;
     color: #fff;
}
 .ant-menu-inline > .ant-menu-item{
   height:65px;
   line-height:65px;
   font-size:16px;
 }
 .ant-menu-dark .ant-menu-inline.ant-menu-sub {
    background: #fff;
    box-shadow: none;
}
.ant-menu-dark ,.ant-menu-dark .ant-menu-sub {
    background: #fff !important;
    color: #333;
}
.ant-menu-dark.ant-menu-inline .ant-menu-submenu-title {
  color:#333;
  /* text-align: center; */
  padding-left: 20px;
  font-size:16px;
  /* background:pink; */
  height:65px;
  line-height:65px;
}
.mine .ant-menu-vertical-right .ant-menu-item:not(:last-child),
.ant-menu-inline .ant-menu-item:not(:last-child) {
  margin-bottom: 0px;
}
.mine .ant-menu-vertical-right .ant-menu-item,
.ant-menu-inline .ant-menu-item,
.ant-menu-vertical .ant-menu-submenu-title,
.ant-menu-vertical-left .ant-menu-submenu-title,
.ant-menu-vertical-right .ant-menu-submenu-title,
.ant-menu-inline .ant-menu-submenu-title {
  margin-top: 0px;
  margin-bottom: 0px;
}
.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow::after, 
.ant-menu-dark .ant-menu-sub 
.ant-menu-submenu-title .ant-menu-submenu-arrow::after{
    background: #000;
}
.mine .ant-menu-inline .ant-menu-submenu {
  margin-bottom: 0 !important;
  background: #fff;
  color: #333;
}
.ant-layout-sider-children {
    margin-top: -0.1px;
    padding-top: 0.1px;
   background:#eee;
}
.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow, 
.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow {
    color:#000;
    background:#000;
}
.ant-menu-sub.ant-menu-inline > .ant-menu-item {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    /* background: #fff; */
    font-size: 16px;
}
.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow::before{
  background:#000;
      color:#000;
}
.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,
 .ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after{
   background:#000;
       color:#000;
 }
 .ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,
 .ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before{
   background:#000;
       color:#000;
 }
</style>
<style lang="stylus" scoped>
.mine
  border-top: 1px solid #eee;
  overflow hidden
  background:#eee;
  .banner
    margin:0 auto;
    height:123px;
    background-color: #4281ff;
    text-align center;
    position relative
    .roleshow
      position:absolute;
      width:1205px;
      bottom:17px;
      left:50%;
      transform:translateX(-50%)
      z-index 555;
      // position relative
      p
        position:absolute;
        margin-bottom:0px;
        overflow:hidden;
        height:26px;
        line-height:26px;
        right:0;
        bottom:0px;
        span:nth-child(1)
          font-size: 20px;
          color: #ffffff;
          margin-right:15px;
        span:nth-child(2)
          width: 61px;
          height: 20px;
          background-color: #fbf2e6;
          border-radius: 3px;
          font-size: 14px;
          color: #9d6414;
          padding-left:8px;
          padding-right:8px;
          text-align center
        span:nth-child(3)
          width: 61px;
          height: 20px;
          background-color: #fbf2e6;
          border-radius: 3px;
          font-size: 14px;
          margin-left:15px;
          padding-left:8px;
          padding-right:8px;
          color: #9d6414;
          text-align center
  .content 
    margin: 0 auto;
    width: 1205px;
    margin-top:11px;
    min-height: 500px;
    margin-bottom: 30px;

.gohead {
  width: 66px;
  height: 58px;
  background-color: #f9f9fa;
  border-radius: 3px;
  border: solid 1px #eeeeee;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  right: 240px;
  bottom: 50px;
  cursor: pointer;

  a {
    width: 33px;
    height: 32px;
    display: inline;
    text-align: center;
    background: url('../assets/home/gohead3.png') -18px -15px no-repeat;
  }
}

.gohead:hover {
  a {
    background: url('../assets/home/gohead4.png') -18px -15px no-repeat;
  }
}

.gohead:active {
  a {
    background: url('../assets/home/gohead4.png') -18px -15px no-repeat;
  }
}

</style>
